import * as z from "zod";

export const ConfirmCreateBundleSchema = z.object({
  recommendedProducts: z.array(z.string()),
  discountPercentage: z.number(),
});
export type ConfirmCreateBundle = z.infer<typeof ConfirmCreateBundleSchema>;
